import alerts from './alerts'
import routes from './routes'
import login from './login'
import profile from './profile'
import datatable from './datatable'
import details from './details'
import itemElements from './item-elements'

export default {
  global: {
    alerts,
    routes,
    login,
    profile,
    datatable,
    details,
    itemElements,
  },
}
